import { render, staticRenderFns } from "./OriginCityBlock.vue?vue&type=template&id=77d43371&"
import script from "./OriginCityBlock.vue?vue&type=script&lang=js&"
export * from "./OriginCityBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports